import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react"
import Loader from "../UI/Loader.tsx"
import { RemoteAPI } from "../../appointmentApi.tsx";
import { AppointmentDate, AppointmentTypes, onSelectDateCallback } from "../../Models/Types.ts";
import Slots from "./Components/Slots.tsx";
import { getFormattedDate } from "../../Utils/StringFunctions.ts";

interface SlotDateProps {
    appointmentType: AppointmentTypes,
    customersQuantity: number,
    onSelectDate: onSelectDateCallback,
    womanNumber: any,
    manNumber: any
}

const SlotDate = (props: SlotDateProps) => {
    const { appointmentType, onSelectDate, womanNumber, manNumber } = props;
    const [date, setDate] = useState<string>("");
    const [appointments, setAppointments] = useState<Array<AppointmentDate>>([]);
    const [loadMoreDate, setLoadMoreDate] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isLoadingLoadMore, setIsLoadingLoadMore] = useState<boolean>(false)

    const loadAppointmentDates = useCallback(async (loaderToggle: Dispatch<SetStateAction<boolean>>, loadMoreDate: string = "") => {
        try {
            loaderToggle(true)
            const result = await RemoteAPI.fetchAppointments(appointmentType, manNumber, womanNumber, loadMoreDate !== "" ? loadMoreDate : date);

            setLoadMoreDate(result.date_next_request);
            if (loadMoreDate !== "") {
                setAppointments(old => [...old, ...result.dates])
            }
            else {
                setAppointments(result.dates);
            }
            loaderToggle(false)
        } catch (error) {
            loaderToggle(false)
            setAppointments([])
        }
    }, [date, setAppointments, setLoadMoreDate, setIsLoading])

    useEffect(() => {
        loadAppointmentDates(setIsLoading)
    }, [setIsLoading, date])

    const dateInputMin = useMemo(() => {
        const today = new Date();

        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        return getFormattedDate(tomorrow);
    }, [])

    return (
        <>
            {isLoading ?
                <div style={{ width: "100%", height: "100%", justifyContent: "center", alignItems: "center", display: "flex" }}>
                    <Loader />
                </div>

                :
                <>
                    <div id="container-select-type-appointment" className="container-select-type-appointment">

                        <div id="container-date-input-appointment" className="container-date-input-appointment">
                            <label htmlFor="date-input">Data appuntamento</label>
                            <input type="date" id="date-input" value={date} min={dateInputMin} onChange={e => setDate(e.target.value)} />
                        </div>

                    </div>
                    <div id="slot-date-container" className="slot-date-container">
                        <div id="date-container">
                        </div>
                        {appointments.length === 0 ? <div className="no-data-container" id="no-data-container">Nessun appuntamento disponibile</div>
                            :
                            <div id="container-tiles-slot" className="container-tiles-slot">
                                <div className="tiles-container" id="tiles-container">
                                    {appointments.map(appointmentDate => <Slots appointmentDate={appointmentDate} onSelectDate={onSelectDate} />)}
                                </div>
                                <div className="container-button-load-more">
                                    {isLoadingLoadMore && <img className=" loader-gif-button" id="loader-gif-button" src="/calendario-appuntamenti/images/Spinner-3.gif" />}
                                    {
                                        <button onClick={() => loadAppointmentDates(setIsLoadingLoadMore, loadMoreDate)} className="button-load-more">
                                            Carica altri giorni
                                        </button>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </>

            }
        </>
    )
}

export default SlotDate